import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from "firebase/firestore"
// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA93DmGXY6ihwB8JBr0VFBO6RyIQKJJSc8",
  authDomain: "enermetispowergrid.firebaseapp.com",
  projectId: "enermetispowergrid",
  storageBucket: "enermetispowergrid.firebasestorage.app",
  messagingSenderId: "801468530730",
  appId: "1:801468530730:web:e6498317a204196e428353",
  measurementId: "G-SXJ1L7KVBB",
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)
export const db = getFirestore(app)

export default app

